type EventBase = {
  [event: string]: (...args: never[]) => void;
};

export class EventEmitter<T extends EventBase> {
  private listeners: { [E in keyof T]?: T[E][] } = {};

  public destroy(): void {
    this.listeners = {};
  }

  public emit<E extends keyof T>(event: E, ...args: Parameters<T[E]>): void {
    this.listeners[event]?.forEach((listener) => {
      listener(...args);
    });
  }

  public on<E extends keyof T>(event: E, listener: T[E]): void {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event]?.push(listener);
  }

  public off<E extends keyof T>(event: E, listener: T[E]): void {
    const eventListeners = this.listeners[event];
    if (eventListeners) {
      this.listeners[event] = eventListeners.filter((l) => l !== listener);
    }
  }
}
